export default __webpack_public_path__ + "static/media/slider2en.2efb69c6.jpg";